export const LANG_KEY = 'gds_lang';
